import Styles from './PlanCard.module.scss';
import FeatherIcon from 'feather-icons-react';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { usePlans } from 'components/lib';
import { useNavigate } from 'react-router-dom';


export function PlanCard({ plan }) {

    const navigate = useNavigate();

    return (
        <div
            id='planHolder'
            className={Styles.planHolder}
            style={{
                backgroundColor: plan.recommended ? "#1450a0" : "transparent",
                color: plan.recommended ? "white" : "black"
            }}
        >
            <span>
                <p>{plan.name}</p>
                <div id='featureHolder'>
                    {
                        plan.features.map((feature, item) => (
                            <span key={`${feature.name}`}>
                                {feature.checked ?
                                    (
                                        <FeatherIcon
                                            color={plan.recommended ? 'white' : 'black'}
                                            icon='check'
                                            size='20'
                                        />
                                    ) : (
                                        <FeatherIcon
                                            color={plan.recommended ? 'red' : 'black'}
                                            icon='x'
                                            size='20'
                                        />
                                    )
                                }
                                <p>
                                    {feature.name}
                                </p>
                            </span>
                        ))
                    }
                </div>
            </span>
            <span>
                {
                    plan?.in_app &&
                    <span style={{
                        fontSize: "0.7em",
                        textAlign: "left",
                        // marginBottom: "-1em"
                    }}>
                        In-App Purchase
                    </span>
                }
                {!plan?.hide_price &&
                    <p>
                        <b>
                            {plan?.currency?.symbol}{plan.price}
                        </b>
                        <span style={{
                            fontSize: '0.8em',
                            opacity: "0.6",
                            fontWeight: "normal",
                        }}>
                            {plan.interval && '/'}{plan.interval}
                        </span>
                    </p>
                }
                <AivagamButton
                    id="accessAivagamButton"
                    onClick={() => {
                        if (plan?.payment_method === "external") {
                            navigate('/contact');
                        } else {
                            navigate('/signup');
                        }
                    }}
                    buttonText={plan?.enterprise ? 'Contact Us' : 'Sign Up'}
                    classStyles={{
                        width: "100%",
                        border: plan.recommended ? "1.5px solid white" : "none",
                    }}
                />
            </span>
        </div>
    )
}

export function PlanComponent() {

    const shitPlans = usePlans();
    const plans = shitPlans?.data?.raw?.plans;

    return (
        <div id='plansContainer' className={Styles.plansContainer}>
            {
                plans?.map((plan, index) => {
                    if (plan.archived) {
                        return null;
                    } else {
                        return <PlanCard
                            plan={plan}
                            key={`${plan.name}${index}`}
                        />
                    }
                })
            }
        </div>
    )
}